import lazy from 'Snippets/LazyLoad'

export { Introduction } from './Introduction'

export const Draggerjs = lazy(() => import('./Draggerjs')) 

export const Poppingjs = lazy(() => import('./Poppingjs')) 